export const handleRenderTitleLoading = (title: string, isLoading: boolean) => {
    return `${title} ${isLoading ? "..." : ""}`;
};
